var NavItems = {

    admin_resources: "Admin Resources",
    location_manager: "Location Manager",
    member_resources: "Member Resources",
    subscriptions: "Subscriptions",
    purchase_history: "Purchase History",
    admin_query_report: "Admin Query Report",
    admin_location_report: "Admin Location Report",

    sanitize: function(title) {
        return title.toLowerCase().replace(/ /g,"_");
    }

};

export default NavItems;


// WEBPACK FOOTER //
// ./src/components/admin-nav/NavItems.js